import $ from "jquery";
import PubSub from 'pubsub-js';

export default function Offcanvas(xssidebarclass) {
  PubSub.subscribe('core.attach', this.attach.bind(this));
  this.isFilterOffcanvas = xssidebarclass === undefined;
  xssidebarclass = xssidebarclass ? xssidebarclass : "product-filter-list";

  this.sidebarselector = ".sidebar-offcanvas." + xssidebarclass;
  this.xssidebarclass = xssidebarclass + " xs-sidebar-offcanvas";
  this.xssidebarselector = ".xs-sidebar-offcanvas." + xssidebarclass;
  this.xssidebarcloneselector = ".xs-sidebar-offcanvas-clone";
}

function showTeasersIfFilterIsNotActive() {
  const checkboxes = $(".eClick");
  let checked = false;
  for (let i = 0, n = checkboxes.length; i < n; i++) {
    if (checkboxes[i].checked) {
      checked = true;
      break;
    }
  }
  if (!checked) {
    showTeasers();
  }
}

function hideTeasers() {
  $(".js_hide-when-filter-active").hide();
}

function showTeasers() {
  $(".js_hide-when-filter-active").show();
}

Offcanvas.prototype = {
  attach: function () {
    if (this.isxs && !$(this.sidebarselector).is(':empty')) {
      this.switchIt(this.isxs);
    }
  },
  active: function () {
    return $("body").hasClass("offcanvas");
  },
  selectSidebar: function () {
    $(".xs-sidebar-offcanvas").hide();
    $(this.xssidebarselector).show();
  },
  show: function () {
    hideTeasers();
    this.selectSidebar();

    const $body = $("body");
    $body.addClass("offcanvas");
    if (this.isFilterOffcanvas) {
      $body.addClass("offcanvas-filter");
    }

    $('html, body').animate({scrollTop: $(".offcanvas").offset().top}, 300);

  },
  deactivatePage: function () {
    $("#page").off("click");
  },
  hide: function () {
    showTeasersIfFilterIsNotActive();
    const $body = $("body");
    $body.removeClass("offcanvas");
    if (this.isFilterOffcanvas) {
      $body.removeClass("offcanvas-filter");
    }
    this.deactivatePage();
  },
  toggle: function () {
    if ($("body").hasClass("offcanvas")) {
      this.hide();
    } else {
      this.show();
    }
  },
  switchIt: function (on_off, replace) {
    if (!replace && on_off === this.isxs) {
      return;
    }

    this.isxs = on_off;

    if (on_off) { // enter sidebar
      if ($(this.xssidebarselector).length === 0) {
        $("body").prepend('<div class="' + this.xssidebarclass + '">');
      }
      const markup = $(this.sidebarselector).html();

      $(this.xssidebarselector).html(markup);
      $(this.xssidebarcloneselector).html(markup);

      $(this.sidebarselector).empty();

      PubSub.publish("core.attach", $(this.xssidebarselector));
    } else { // exit sidebar
      $(this.sidebarselector).html($(this.xssidebarselector).html());
      $(this.xssidebarselector).remove();
      PubSub.publish("core.attach", $(this.sidebarselector));
      this.hide();
    }
  }
};

